import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  pure: true,
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, args: (string | number)[]): string {
    if (!value) return '';

    const limit = args.length > 0 ? parseInt(args[0].toString(), 10) : 10;
    const trail = args.length > 1 ? args[1].toString() : '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}
